import React, { useEffect } from 'react';
import './LegalNotice.css';

function LegalNotice() {
  useEffect(() => {
    document.title = 'Mentions légales — JMD Informatique';
    document.querySelector('meta[name="description"]')
      ?.setAttribute('content', 'Mentions légales du site jmdinformatique.com — éditeur, hébergeur, propriété intellectuelle, données personnelles (RGPD).');
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="legal" id="main-content">
      <div className="legal__inner">
        <h1 className="legal__title">Mentions légales</h1>
        <p className="legal__intro">
          Conformément aux dispositions de la loi n°2004-575 du 21 juin 2004 pour la Confiance dans
          l'Économie Numérique (LCEN), les présentes mentions légales précisent l'identité des
          différents intervenants dans le cadre de la réalisation et du suivi du site{' '}
          <strong>www.jmdinformatique.com</strong>.
        </p>

        {/* 1. Éditeur */}
        <section className="legal__section">
          <h2 className="legal__section-title">1. Éditeur du site</h2>
          <ul className="legal__list">
            <li><span className="legal__label">Nom et prénom</span> Julien Dabadie</li>
            <li><span className="legal__label">Statut juridique</span> Micro-entrepreneur (Auto-entrepreneur)</li>
            <li><span className="legal__label">Nom commercial</span> JMD Informatique</li>
            <li><span className="legal__label">SIRET</span> 103 158 135 00014</li>
            <li><span className="legal__label">Adresse</span> 110 chemin de Mouret, Villa 7 — 83140 Six-Fours-les-Plages, France</li>
            <li><span className="legal__label">Téléphone</span> <a href="tel:0781165306">07 81 16 53 06</a></li>
            <li><span className="legal__label">Email</span> <a href="mailto:contact@jmdinformatique.com">contact@jmdinformatique.com</a></li>
            <li><span className="legal__label">Site web</span> <a href="https://www.jmdinformatique.com" rel="canonical">www.jmdinformatique.com</a></li>
          </ul>
        </section>

        {/* 2. Directeur de publication */}
        <section className="legal__section">
          <h2 className="legal__section-title">2. Directeur de la publication</h2>
          <p>
            Le directeur de la publication est <strong>Julien Dabadie</strong>, en sa qualité de
            responsable de la micro-entreprise JMD Informatique.
          </p>
        </section>

        {/* 3. Hébergement */}
        <section className="legal__section">
          <h2 className="legal__section-title">3. Hébergement</h2>
          <ul className="legal__list">
            <li><span className="legal__label">Hébergeur</span> O2Switch SARL</li>
            <li><span className="legal__label">Adresse</span> Chemin des Pardiaux — 63000 Clermont-Ferrand, France</li>
            <li><span className="legal__label">Téléphone</span> 04 44 44 60 40</li>
            <li><span className="legal__label">Site web</span> <a href="https://www.o2switch.fr" target="_blank" rel="noreferrer">www.o2switch.fr</a></li>
          </ul>
        </section>

        {/* 4. Propriété intellectuelle */}
        <section className="legal__section">
          <h2 className="legal__section-title">4. Propriété intellectuelle</h2>
          <p>
            L'ensemble des éléments constituant ce site (textes, images, graphismes, logo, icônes,
            sons, logiciels…) est la propriété exclusive de JMD Informatique ou de ses partenaires.
            Toute reproduction, représentation, modification, publication ou adaptation de tout ou
            partie des éléments du site, quel que soit le moyen ou le procédé utilisé, est interdite,
            sauf autorisation écrite préalable de Julien Dabadie.
          </p>
          <p>
            Toute exploitation non autorisée du site ou de l'un quelconque des éléments qu'il contient
            sera considérée comme constitutive d'une contrefaçon et poursuivie conformément aux
            dispositions des articles L.335-2 et suivants du Code de Propriété Intellectuelle.
          </p>
        </section>

        {/* 5. Données personnelles */}
        <section className="legal__section">
          <h2 className="legal__section-title">5. Données personnelles (RGPD)</h2>
          <p>
            Conformément au Règlement Général sur la Protection des Données (RGPD — UE 2016/679) et
            à la loi n°78-17 du 6 janvier 1978 relative à l'informatique, aux fichiers et aux
            libertés, vous disposez de droits sur vos données personnelles.
          </p>

          <h3 className="legal__subsection-title">Données collectées</h3>
          <p>
            Via le formulaire de contact, les informations suivantes peuvent être collectées : nom,
            prénom, adresse email, numéro de téléphone, et le contenu de votre message. Ces données
            sont utilisées <strong>uniquement</strong> pour répondre à votre demande et ne sont
            jamais cédées à des tiers.
          </p>

          <h3 className="legal__subsection-title">Durée de conservation</h3>
          <p>
            Les données transmises via le formulaire de contact sont conservées le temps nécessaire
            au traitement de la demande, et au maximum 3 ans conformément aux recommandations de la
            CNIL.
          </p>

          <h3 className="legal__subsection-title">Vos droits</h3>
          <p>
            Conformément à la réglementation en vigueur, vous disposez des droits suivants sur vos
            données : accès, rectification, effacement, opposition, limitation du traitement et
            portabilité. Pour exercer ces droits, contactez : <a href="mailto:contact@jmdinformatique.com">contact@jmdinformatique.com</a>.
          </p>
          <p>
            Vous avez également le droit d'introduire une réclamation auprès de la{' '}
            <a href="https://www.cnil.fr" target="_blank" rel="noreferrer">CNIL</a> (Commission
            Nationale de l'Informatique et des Libertés).
          </p>
        </section>

        {/* 6. Cookies */}
        <section className="legal__section">
          <h2 className="legal__section-title">6. Cookies</h2>
          <p>
            Ce site n'utilise pas de cookies publicitaires ou de traçage tiers. Des cookies
            techniques strictement nécessaires au bon fonctionnement du site peuvent être déposés.
            Ils ne requièrent pas votre consentement préalable au sens de la directive ePrivacy.
          </p>
        </section>

        {/* 7. Responsabilité */}
        <section className="legal__section">
          <h2 className="legal__section-title">7. Limitation de responsabilité</h2>
          <p>
            JMD Informatique s'efforce d'assurer l'exactitude et la mise à jour des informations
            diffusées sur ce site. Toutefois, JMD Informatique ne peut garantir l'exactitude,
            la précision ou l'exhaustivité des informations mises à disposition.
          </p>
          <p>
            JMD Informatique décline toute responsabilité pour tout dommage résultant de
            l'utilisation du site, d'une interruption de service ou de la présence de liens
            hypertextes vers des sites tiers dont le contenu échappe à son contrôle.
          </p>
        </section>

        <p className="legal__updated">
          Dernière mise à jour : avril 2026
        </p>
      </div>
    </div>
  );
}

export default LegalNotice;
